module.exports = __webpack_public_path__ + "assets/img/product-government2.ef909e18.png";